export default "__VITE_ASSET__sZ1wXOkf__"